import { ApiContext } from '../../types'
import {
  deserializeAudio,
  deserializeSegment,
} from '@/api_client/api/serializers/audio'
import { Audio } from '@/api_client/types/audios'
import { AuthHelper } from '@/api_client'

export default async function generateStripeSubscriptionManagementUrl(
  { client, config }: ApiContext,
  params = {},
): Promise<string> {
  try {
    const bearerToken = AuthHelper.getAccessToken()
    console.log('generateStripeSubscriptionManagementUrl: ', params)
    const result =
      await client.purchases.generateStripeSubscriptionManagementUrl(
        bearerToken.toString(),
        params,
      )
    if (result.isSuccess()) {
      console.log('result11111')
      console.log(result)
      const payload = result.success()
      return payload
    } else {
      console.log(result.fail())
      return null
    }
  } catch (e) {
    console.error(e)
    // throw e
    return null
  }
}
